<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'" v-else>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }">
        <a-card :loading="pageLoading" class="margin-bottom">
          <div slot="title">Pipeline Manifest</div>

          <div class="m-card-body">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <div class="lbldesc"><b>Create Date :</b></div>
                <div class="lbldeschead">{{ moment(data.header.create_dt).format('DD-MM-YYYY') }}</div>
                <div class="lbldesc"><b>Product :</b></div>
                <div class="lbldeschead">{{ data.header.definitions }}</div>
                <div class="lbldesc"><b>Description :</b></div>
                <div class="lbldeschead">{{ data.header.description }}</div>
                <div class="lbldesc"><b>Customer Name :</b></div>
                <div class="lbldeschead">{{ data.header.client }}</div>
                <div class="lbldesc"><b>Marketing/IBD :</b></div>
                <div class="lbldeschead">{{ data.header.pic_am ? data.header.pic_am : '-' }}</div>
                <div class="lbldesc"><b>Pimpro :</b></div>
                <div class="lbldeschead">{{ data.header.pic_pimpro ? data.header.pic_pimpro : '-' }}</div>
                <div class="lbldesc"><b>Contact Detail :</b></div>
                <div class="lbldeschead">{{ data.header.contact_detail ? data.header.contact_detail : '-' }}</div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <div class="lbldesc"><b>TLC Create :</b></div>
                <div class="lbldeschead">{{ data.header.tlc_create }}</div>
                <!-- <div class="lbldesc"><b>Currency :</b></div>
                <div class="lbldeschead">{{ data.header.currency }}</div> -->
                <div class="lbldesc"><b>Est. Contract Value (IDR):</b></div>
                <div class="lbldeschead">{{ formatCurrency(data.header.currency,data.header.est_contract_value).replaceAll('Rp','') }}</div>
                <div class="lbldesc"><b>Est Operasional Cost (IDR):&nbsp;</b>
                  <!-- <a-button type="danger" size="small" icon="edit"
                    v-if="isCOO"
                    @click="modalEditOperasionalCost = true;modalEditOperasionalCostValue=data.header.est_operasional_cost">Edit</a-button> -->
                </div>
                <div class="lbldeschead">{{ formatCurrency(data.header.currency,data.header.est_operasional_cost).replaceAll('Rp','') }}</div>
                <div class="lbldesc"><b>Est Marketing Cost (IDR):</b></div>
                <div class="lbldeschead">{{ formatCurrency(data.header.currency,data.header.est_marketing_cost).replaceAll('Rp','') }}</div>
                <div class="lbldesc"><b>Est GA Cost (IDR):</b></div>
                <div class="lbldeschead">{{ formatCurrency(data.header.currency,data.header.est_ga_cost).replaceAll('Rp','') }}</div>
                <div class="lbldesc"><b>Est Finance Cost (IDR):</b>
                  <!-- <a-button type="danger" size="small" icon="edit"
                    v-if="isVPF"
                    @click="modalEditFinanceCost = true;modalEditFinanceCostValue=data.header.est_finance_cost">Edit</a-button> -->
                </div>
                <div class="lbldeschead">{{ formatCurrency(data.header.currency,data.header.est_finance_cost).replaceAll('Rp','') }}</div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <div class="lbldesc"><b>Status :</b></div>
                <div class="lbldeschead">{{ data.header.status }}</div>
                <div v-if="data.header.status=='PROSPECT'" class="lbldesc"><b>Prospect Progress :</b></div>
                <div v-if="data.header.status=='PROSPECT'" class="lbldeschead">
                  {{ data.header.prospect_progress ? data.header.prospect_progress: 0 }}%</div>
                <!-- <div class="lbldesc"><b>Exchange rate :</b></div>
                <div class="lbldeschead">{{ formatRupiah(data.header.kurs).replace('Rp','') }}</div> -->
                <div class="lbldesc"><b>year :</b></div>
                <div class="lbldeschead">{{ data.header.year }}</div>
                <div class="lbldesc"><b>Category :</b></div>
                <div class="lbldeschead">{{ data.header.kategori }}</div>
                <div v-if="data.salesnotif[0]">
                <div class="lbldesc"><b>Sales Notification :</b></div>
                  <div class="lbldeschead">{{ data.salesnotif[0].no_salesnotif }}</div>
                </div>
                <div class="lbldesc"><b>Note :</b></div>
                <div class="lbldeschead">{{ data.header.notes }}</div>
              </a-col>
            </a-row>
          </div>
        </a-card>
        <!-- <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <h4 slot="header" class="margin-remove">Usage Details</h4>
            -- <a-input-search
                    v-model="search"
                    placeholder="Quick Search"
                    allowClear
                    :change="searching"
                    class="margin-bottom"
            /> --
            <a-table
                    :columns="columns"
                    :dataSource="data.tableData"
                    :pagination="pagination"
                    rowKey="id_sppd_dtl"
                    size="small"
                    bordered
                    :scroll="{ x: 100 }">
              <template slot="no" slot-scope="item,text,index">
                {{ index+1 }}
              </template>
              <template slot="anggaran" slot-scope="item">
                <span>{{item.item_anggaran}}</span><br/>
                <b>{{item.kode_anggaran}}</b>
              </template>
              <template slot="val" slot-scope="item">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="item.value" />
              </template>
            </a-table>
          </a-collapse-panel>
        </a-collapse> -->
        <a-collapse class="margin-top" activeKey>
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="data.last_status" />
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ data.user_pembuat.tlc }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ data.user_pembuat.tanggal }}</h4>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                </div>
              </a-timeline-item>
              <a-timeline-item
                v-for="workflow in data.status"
                :key="workflow.step_no"
                :color="
                  workflow.status === 'On Process' ||
                  workflow.status === 'Delivered'
                    ? 'red'
                    : workflow.status === 'Waiting'
                    ? 'grey'
                    : 'green'
                "
              >
                <div class="m-timeline-title">
                  {{
                    workflow.actor === null ? workflow.jenis : workflow.actor
                  }}
                  {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4
                    class="margin-remove"
                    v-if="workflow.tanggal_aksi !== null"
                  >
                    {{ workflow.tanggal_aksi }}
                  </h4>
                  <span
                    class="m-text-small"
                    v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span
                  >
                  <span class="m-text-small" v-else>{{ workflow.remark }}</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>
        

        <a-card
          class="margin-top"
          :loading="pageLoading"
          v-if="data.jenis.toLowerCase() === 'approve'"
        >
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="2"
                v-decorator="['catatan']"
              />
            </a-form-item>
            <a-form-item label="Actions">
              <a-select
                showSearch
                v-decorator="['aksi', { rules: [{ required: true }] }]"
              >
                <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                  item.aksi
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Password">
              <a-input
                type="password"
                placeholder="Password"
                v-decorator="['password', { rules: [{ required: true }] }]"
              />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button
                @click="handleSubmit"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  mixins: [CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      data: {},
      submit: {},
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters(["getScreen"]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          scopedSlots: { customRender: "no" },
          key: "no",
          width: "50px",
          align: "right",
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Activity Name",
          dataIndex: "item_nm",
          width: "200px",
          key: "item_nm",
        },
        {
          title: "Value",
          scopedSlots: { customRender: "val" },
          width: "150px",
          key: "val",
        },
        {
          title: "Anggaran",
          key: "kode_anggaran",
          width: "200px",
          scopedSlots: { customRender: "anggaran" },
        },

      ];
      return kolom;
    },
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_pipeline",
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          this.data = {
            header: response.data.pipeline[0],
            tableData: [],
            salesnotif: response.data.salesnotif,
            actor: "response.data.tlc",
            id: response.data.pipeline[0].pipeline_id,
            jenis: response.data.jenis,
            last_status: response.data.status_besar,
            user_pembuat: {
              tlc: response.data.pipeline[0].tlc_create,
              tanggal: response.data.pipeline[0].create_dt,
              status: "Created",
            },
            status: response.data.workflow,
            aksi: response.data.aksi,
          };
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
        });
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.pageLoading = false;
          this.displayMessage("choose-action");
          return;
        }

        let postData = new FormData();

        postData.append("id_manifest", this.data.id);
        postData.append("status", values.aksi);
        postData.append(
          "remark",
          values.catatan !== undefined ? values.catatan : ""
        );
        postData.append("tlc", this.data.actor);
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_pipeline",
          processData: false,
          data: postData,
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.displayMessage("wrong-password");
            }
            this.pageLoading = false;
          });
      });
    },
  },
};
</script>

<style>
</style> 